import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import Icon from '../../../components/Icon/Icon';
import infoIcon from '../../../assets/img/info.svg';
import styles from '../../Consent Request/Create/CreateConsentRequest.module.css';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import Error from '../../../components/Error/Error';

const CustomPurposeTextInput = ({
  value,
  purpose,
  setFilteredCustomPurposeText,
  filteredCustomPurposeText,
  setFieldValue,
  touched,
  errors,
}) => {
  return (
    <div className={styles['input__container']}>
      <div className={styles['label__container']}>
        <label htmlFor="purpose" className={styles['input-label']}>
          Purpose Text:
        </label>
        <img
          src={infoIcon}
          className={`${styles.info} purpose-tooltip`}
          alt="tooltip"
          data-pr-tooltip="Enter the purpose of the consent template."
        />
      </div>

      <Tooltip target=".purpose-tooltip" className={styles.tooltip} />

      <div className="p-inputgroup">
        <Icon icon="question_exchange" className="p-inputgroup-addon" />
        <InputText
          id="purpose.text"
          name="purpose.text"
          value={value || ''}
          onChange={(e) => {
            setFieldValue('customPurposeText', e.target.value);
          }}
          onBlur={() => {
            if (!value) {
              toast.error('Please enter a valid purpose code.', {
                position: 'top-right',
                autoClose: 4000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            }
          }}
          placeholder="Enter purpose of consent"
        />
      </div>

      <small className={styles.helper}>
				For more information on purposes, click{' '}
				<a
					href="https://sahamati.org.in/aa-fair-use-template-library/"
					target="_blank"
					rel="noreferrer noopener"
				>
					here
				</a>
			</small>
			{touched.purpose && errors.purpose ? (
				<Error>{errors.purpose.text}</Error>
			) : null}
    </div>
  );
};

export default CustomPurposeTextInput;